export default {
  name: 'checkbox',
};



// WEBPACK FOOTER //
// ./node_modules/framework7/components/checkbox/checkbox.js